import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import { normalizeClass, toDisplayString } from "../../node_modules/.pnpm/@vue_shared@3.5.13/node_modules/@vue/shared/dist/shared.esm-bundler.es.js";
import { defineComponent, openBlock, createElementBlock, createElementVNode as createBaseVNode, createCommentVNode } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
const _hoisted_1 = { class: "ws-delimiter" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsDelimiter",
  props: {
    text: {
      type: String,
      default: ""
    },
    textClass: {
      type: String,
      default: ""
    },
    lineClass: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createBaseVNode("div", {
          class: normalizeClass(["ws-delimiter__line", __props.lineClass])
        }, null, 2),
        __props.text ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["ws-delimiter__text ws-typo-xs", __props.textClass])
        }, toDisplayString(_ctx.$t(__props.text)), 3)) : createCommentVNode("", true),
        __props.text ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["ws-delimiter__line", __props.lineClass])
        }, null, 2)) : createCommentVNode("", true)
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsDelimiter.vue.es2.js.map
